module.exports = __webpack_public_path__ + "img/dsci0022.cbdc8c81.jpg";